export default function TitleBar() {
  return (
    <section className="px-4 sm:px-6 lg:px-8 pt-8 pb-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="section-title text-2xl sm:text-3xl">Franchise Math</h1>
        <p className="text-sm text-graphite mt-1">Forbes says what. We say why.</p>
      </div>
    </section>
  )
}
